import { Col } from "reactstrap";
import { H4 } from "../../../../AbstractElements";
import { DarkBackground } from "../../../../Constant";
import { DARK_BACKGROUND } from "../../../../Data/UiKit/HelperClasses";

export const DarkBackgrounds = () => {
  return (
    <Col xl="4" sm="6">
      <div className="border-wrapper h-100 border">
        <H4 className="mb-3">{DarkBackground}</H4>
        <div className="d-flex align-items-center mb-2 gap-2">
          <div className="helper-box bg-primary"></div>.bg-primary
        </div>
        {DARK_BACKGROUND.map((item, index) => (
          <div className="d-flex align-items-center mb-2 gap-2" key={index}>
            <div className={`helper-box ${item}`}></div>.{item}
          </div>
        ))}
      </div>
    </Col>
  );
};
